const VENDOR_DOMAINS = [
  'vendor.raybiztech.com',
  'vendorqa2.raybiztech.com',
  'vendoruat.raybiztech.com',
  'vendorcore.raybiztech.com',
  'vendor.local',
]

//const OVH_DOMAINS = ['ovh.raybiztech.com', 'ovh.local']

export const isVendorDomain = (): boolean => {
  const { hostname } = window.location
  return VENDOR_DOMAINS.includes(hostname)
}

// export const isOvhDomain = (): boolean => {
//   const { hostname } = window.location
//   return OVH_DOMAINS.includes(hostname)
// }

export const getDomainType = (): 'vendor' | 'ovh' => {
  if (isVendorDomain()) return 'vendor'
  return 'ovh'
}

export const getLoginPath = (): string => {
  return isVendorDomain() ? '/vendorLogin' : '/login'
}

export const getDefaultLoginRedirect = (): string => {
  return getLoginPath()
}
